.qr-canvas {
  max-height: 60vh;
  max-width: 80vw;
  text-align: center;
}

.qr-canvas > canvas {
  width: 100%;
  height: 100%;
}
